export enum BusinessModeOfPayments {
  TERMINAL = 1,
  ECOM = 2,
  PAYMENT_LINK = 3,
  QRPH = 4,
  PAY_WITH_MAYA = 5,
}
